<div *ngIf="isText" class="d-flex align-items-center gap-1">
    <input type="text" [(ngModel)]="text">
</div>

<div *ngIf="isButton" class="d-flex align-items-center gap-1">
    <button class="vpacs-btn-table" (click)="calcPackage()">CALC PACKAGE
    </button>
</div>